import { render } from "./CtrlNext.vue?vue&type=template&id=68db9065&scoped=true"
import script from "./CtrlNext.vue?vue&type=script&lang=js"
export * from "./CtrlNext.vue?vue&type=script&lang=js"

import "./CtrlNext.vue?vue&type=style&index=0&id=68db9065&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68db9065"]])

export default __exports__